// src/data/products.js

const PRODUCTS = [
  {
    id: '1',
    name: 'iPhone 14 Pro',
    brand: 'Apple',
    category: 'Phone',
    price: 1099,
    image: '/images/iphone14pro.jpg',
    description: '6.1" OLED • A16 Bionic • Pro camera system',
    specs: {
      screen: '6.1" OLED',
      storage: '128 GB',
      ram: '6 GB',
      os: 'iOS 16',
    },
  },
  {
    id: '2',
    name: 'iPhone 14 Pro Max',
    brand: 'Apple',
    category: 'Phone',
    price: 1199,
    image: '/images/iphone14promax.jpg',
    description: '6.7" OLED • A16 Bionic • Pro camera system',
    specs: {
      screen: '6.7" OLED',
      storage: '256 GB',
      ram: '6 GB',
      os: 'iOS 16',
    },
  },
  {
    id: '3',
    name: 'iPhone 15 Pro',
    brand: 'Apple',
    category: 'Phone',
    price: 1099,
    image: '/images/iphone15pro.jpg',
    description: '6.1" OLED • A17 Bionic • Pro camera system',
    specs: {
      screen: '6.1" OLED',
      storage: '128 GB',
      ram: '8 GB',
      os: 'iOS 17',
    },
  },
  {
    id: '4',
    name: 'iPhone 15 Pro Max',
    brand: 'Apple',
    category: 'Phone',
    price: 1199,
    image: '/images/iphone15promax.jpg',
    description: '6.7" OLED • A17 Bionic • Pro camera system',
    specs: {
      screen: '6.7" OLED',
      storage: '256 GB',
      ram: '8 GB',
      os: 'iOS 17',
    },
  },
  {
    id: '5',
    name: 'iPhone 16',
    brand: 'Apple',
    category: 'Phone',
    price: 999,
    image: '/images/iphone16.jpg',
    description: '6.1" OLED • A18 Bionic • Dual-camera system',
    specs: {
      screen: '6.1" OLED',
      storage: '128 GB',
      ram: '8 GB',
      os: 'iOS 18',
    },
  },
  {
    id: '6',
    name: 'iPhone 16 Pro',
    brand: 'Apple',
    category: 'Phone',
    price: 1099,
    image: '/images/iphone16pro.jpg',
    description: '6.1" OLED • A18 Bionic • Pro camera system',
    specs: {
      screen: '6.1" OLED',
      storage: '256 GB',
      ram: '8 GB',
      os: 'iOS 18',
    },
  },
  {
    id: '7',
    name: 'iPhone 16 Pro Max',
    brand: 'Apple',
    category: 'Phone',
    price: 1199,
    image: '/images/iphone16promax.jpg',
    description: '6.7" OLED • A18 Bionic • Pro camera system',
    specs: {
      screen: '6.7" OLED',
      storage: '512 GB',
      ram: '8 GB',
      os: 'iOS 18',
    },
  },
  {
    id: '8',
    name: 'Galaxy S23 Ultra',
    brand: 'Samsung',
    category: 'Phone',
    price: 1199,
    image: '/images/galaxys23ultra.jpg',
    description: '6.8" AMOLED • Snapdragon 8 Gen 2 • 200 MP camera',
    specs: {
      screen: '6.8" AMOLED',
      storage: '256 GB',
      ram: '12 GB',
      os: 'Android 13',
    },
  },
  {
    id: '9',
    name: 'Galaxy S24 Ultra',
    brand: 'Samsung',
    category: 'Phone',
    price: 1299,
    image: '/images/galaxys24ultra.jpg',
    description: '6.8" AMOLED • Snapdragon 8 Gen 3 • 200 MP camera',
    specs: {
      screen: '6.8" AMOLED',
      storage: '256 GB',
      ram: '12 GB',
      os: 'Android 14',
    },
  },
  {
    id: '10',
    name: 'Galaxy S25 Ultra',
    brand: 'Samsung',
    category: 'Phone',
    price: 1399,
    image: '/images/galaxys25ultra.jpg',
    description: '6.9" AMOLED • Snapdragon 8 Gen 4 • 200 MP camera',
    specs: {
      screen: '6.9" AMOLED',
      storage: '512 GB',
      ram: '16 GB',
      os: 'Android 15',
    },
  },
  {
    id: '11',
    name: 'MacBook Air',
    brand: 'Apple',
    category: 'Laptop',
    price: 999,
    image: '/images/macbookair.jpg',
    description: '13.6" Retina • M2 chip • up to 18 h battery',
    specs: {
      screen: '13.6" Retina',
      storage: '256 GB',
      ram: '8 GB',
      os: 'macOS Ventura',
    },
  },
  {
    id: '12',
    name: 'MacBook Pro 14"',
    brand: 'Apple',
    category: 'Laptop',
    price: 1999,
    image: '/images/macbookpro14.jpg',
    description: '14" Liquid Retina XDR • M2 Pro chip • up to 22 h battery',
    specs: {
      screen: '14" LCD',
      storage: '512 GB',
      ram: '16 GB',
      os: 'macOS Ventura',
    },
  },
  {
    id: '13',
    name: 'Dell XPS 13',
    brand: 'Dell',
    category: 'Laptop',
    price: 999,
    image: '/images/dellxps13.jpg',
    description: '13.4" FHD+ • Intel Core i7 • 16 GB RAM',
    specs: {
      screen: '13.4" IPS',
      storage: '512 GB',
      ram: '16 GB',
      os: 'Windows 11',
    },
  },
  {
    id: '14',
    name: 'iPad Air (5th Gen)',
    brand: 'Apple',
    category: 'Tablet',
    price: 599,
    image: '/images/ipadair5.jpg',
    description: '10.9" Liquid Retina • M1 chip • Wi-Fi + Cellular',
    specs: {
      screen: '10.9" LCD',
      storage: '64 GB',
      ram: '8 GB',
      os: 'iPadOS 16',
    },
  },
];

export default PRODUCTS;
